function getLimitOffset({ page, pageSize }: { page: number, pageSize: number }) {
  const formattedPageValue = page ? page - 1 : 0;

  return {
    limit: pageSize || 10,
    offset: (formattedPageValue * pageSize) || 0,
  };
}


export default getLimitOffset;
